import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import Thumbs from './Thumbs';
import DesktopAssets from './DesktopAssets';
import getStyles from './getStyles';
import { getImageRatio } from '../../utils/ProductUtils';

const thumbSize = 50;
const featuredStyles = {
  thumbsetThumbs: {
    display: 'flex',
    flexDirection: 'column',
    width: `${thumbSize}px`
  },
  thumbset: {
    padding: '10px 0',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
    float: 'right',
    justifyContent: 'center',
    marginRight: '-8px'
  },
  imageWrapper: {
    maxWidth: '100%',
    width: '100%',
    overflow: 'hidden'
  }
};
const featuredThumbStyles = {
  thumbWrapper: {
    padding: '2px',
    height: `${thumbSize}px`,
    width: '100%',
    float: 'left',
    position: 'relative',
    margin: '4px 0'
  }
};

function Featured(props) {
  const { Block, Icon } = UX2.Element;
  const { Grid, Grid: { Cell } } = UX2.Component;
  const styles = getStyles(props, featuredStyles);

  return (
    <Block style={{ position: 'relative' }}>
      <Grid size={ 12 }>
        <Cell sm={ 2 }>
          <Block style={ styles.thumbset }>
            {props.isNotFirst && <Block
              id='chevron-left'
              onClick={ props.onAssetStripChangeLeft }
              style={ styles.thumbArrowUp }
              children={ <Icon icon='chevronUp' size='small' /> }
            />}
            <Block id='asset-strip-container' style={{ width: '100%' }}>
              <Block style={ styles.thumbsetThumbs }>
                {props.hasFinalizedAssets && <Thumbs
                  isAssetVisibleInStrip={ props.isAssetVisibleInStrip }
                  isCurrentAsset={ props.isCurrentAsset }
                  onClickThumbnail={ props.onClickThumbnail }
                  assets={ props.assets }
                  styles={ featuredThumbStyles }
                />}
              </Block>
            </Block>
            {props.isNotLast && <Block
              id='chevron-right'
              onClick={ props.onAssetStripChangeRight }
              style={ styles.thumbArrowDown }
              children={ <Icon icon='chevronDown' size='small' /> }
            />}
          </Block>
        </Cell>
        <Cell sm={ 8 }>
          <Block style={ styles.wrapperDesktop }>
            <Block style={ styles.imageWrapper }>
              <Block style={ styles.imageOuter }>
                <DesktopAssets
                  selectedAsset={ props.selectedAsset }
                  product={ props.product }
                  zoomConfig={{
                    disableZoom: !props.zoomEnabled,
                    containerStyle: {
                      position: 'relative',
                      height: '450px',
                      overflow: 'hidden'
                    },
                    enlargedImagePosition: 'over',
                    cropMethod: props.pdpImageCropMethod
                  }}
                  aspectRatio={ getImageRatio(props.pdpImageShape, props.pdpLayout) }
                />
              </Block>
            </Block>
          </Block>
        </Cell>
      </Grid>
    </Block>
  );
}

Featured.propTypes = {
  assets: PropTypes.array,
  hasFinalizedAssets: PropTypes.bool,
  isAssetVisibleInStrip: PropTypes.bool,
  isCurrentAsset: PropTypes.bool,
  isNotFirst: PropTypes.bool,
  isNotLast: PropTypes.bool,
  onAssetStripChangeLeft: PropTypes.func,
  onAssetStripChangeRight: PropTypes.func,
  onClickThumbnail: PropTypes.func,
  pdpImageCropMethod: PropTypes.string,
  product: PropTypes.object,
  selectedAsset: PropTypes.object,
  zoomEnabled: PropTypes.bool,
  pdpImageShape: PropTypes.string,
  pdpLayout: PropTypes.string.isRequired
};

export default Featured;
